import {
  DepartmentAccessLevelDTO,
  DepartmentTreeNodeDTO,
  UserDepartmentDTO,
} from '@/api/trafikportalen';

export interface DepartmentAccess {
  department_id: string;
  name: string;
  access_level: DepartmentAccessLevelDTO;
  isDirect: boolean;
  parentDepartment?: string;
}

/**
 * Mirrors the backend walk: a department without a row of its own gets the
 * level of the nearest ancestor that has one.
 */
export const getAllUserDepartmentAccess = (
  userDepartments: UserDepartmentDTO[],
  departmentTree: DepartmentTreeNodeDTO | undefined,
): DepartmentAccess[] => {
  if (!departmentTree || !userDepartments || userDepartments.length === 0) {
    return [];
  }

  const direct = new Map<string, DepartmentAccess>();
  userDepartments.forEach((dept) => {
    if (dept.department_id && dept.name && !direct.has(dept.department_id)) {
      direct.set(dept.department_id, {
        department_id: dept.department_id,
        name: dept.name,
        access_level: dept.access_level ?? DepartmentAccessLevelDTO.viewer,
        isDirect: true,
      });
    }
  });

  const inherited: DepartmentAccess[] = [];

  const traverse = (
    node: DepartmentTreeNodeDTO,
    nearest?: DepartmentAccess,
  ) => {
    const own = direct.get(node.id);

    if (!own && nearest) {
      inherited.push({
        department_id: node.id,
        name: node.name,
        access_level: nearest.access_level,
        isDirect: false,
        parentDepartment: nearest.name,
      });
    }

    node.children.forEach((child) => traverse(child, own ?? nearest));
  };

  traverse(departmentTree);

  return [...direct.values(), ...inherited];
};
